var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('router-view',{attrs:{"data-aos":"fade-down","data-aos-easing":"linear","data-aos-duration":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }